export const messages = {
  en: () => import('./en'),
  ro: () => import('./ro')
}
